var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerCombined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 352V480C512 497.6 497.6 512 480 512H32C14.4 512 0 497.6 0 480V32C0 14.4 14.4 0 32 0H160C177.6 0 192 14.4 192 32V96H112C103.201 96 96 103.199 96 112S103.201 128 112 128H192V192H112C103.201 192 96 199.199 96 208S103.201 224 112 224H192V288H112C103.201 288 96 295.199 96 304S103.201 320 112 320H192V400C192 408.799 199.199 416 208 416S224 408.799 224 400V320H288V400C288 408.799 295.199 416 304 416S320 408.799 320 400V320H384V400C384 408.799 391.199 416 400 416S416 408.799 416 400V320H480C497.6 320 512 334.4 512 352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerCombined);
export default __webpack_public_path__ + "static/media/ruler-combined.be97e5cb59a0bcb437816e5cda9d91d5.svg";
export { ForwardRef as ReactComponent };